<template>
  <!--  /*铭记历史、致敬胜利*/-->
  <div class="Remember">
    <div class="contentnr">
      <div class="top">
        <div>
          <slot name="plate"></slot>
        </div>
      </div>
      <div class="content">
        <div class="content-listimg clearfix">
          <ul class="Picture-list">
            <div class="looking-forward">
              <span></span>
              <a href="http://yinglie.chinamartyrs.gov.cn/lieshijinianguan/" target="_blank">
                主题公祭
              </a>
            </div>
            <div class="memorial-service">
              <span></span>
              <a href="http://yinglie.chinamartyrs.gov.cn/LingYuanZhanShi/lingyuan/vrlist.html" target="_blank">
                线上瞻仰
              </a>
            </div>
            <div class="content-listimg-left">
              <h3>第三批国家级抗战纪念设施、遗址和著名抗日英烈、英雄群体名录公布
                <br>

              </h3>
              <p class="content-listimg-bottom"></p>
            </div>
          </ul>

          <ul class="content-listimg-right clearfix">
            <div v-show="isdata" class="over">暂无数据</div>
            <li v-for="(item,index) in datalist" :key="index">
              <div class="listimg enlarge"  @click="handleHerf(item.basicId)">
                <img :src=item.basicThumbnail   alt="">
              </div>
              <div class="listtitle" @click="handleHerf(item.basicId)">
                <div class="title-text text-tow-overflow" v-html="item.basicTitle" :title=item.basicTitle>{{item.basicTitle}}</div>
              </div>
            </li>
            <paging  v-show="!isdata" :dataall="screenthreepage.all" :dataCur="screenthreepage.cur" :datanum="screenthreepage.num" :dataDatanum="screenthreepage.dataNum"
                    @change="pageChange"></paging>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import util from '@/assets/js/util'
  import Paging from '@/components/paging'
  import {REMEMBER} from '@/config/global.js'
  import {getmjlsJsondata,getmjlsAjaxdata} from '@/api/rememberhistory.js'
  export default {
    data() {
      return {
        isdata:false,
        columnId:"",
        screenthreepage: {
          all: '', //总页数
          cur: 1, //当前页码
          num: 6, //一页显示的数量  必须是奇数
          dataNum: '', //数据的数量
        },
        screenthreedata: [],
        isdetails: false,
        datalist:""
      }
    },
    mounted() {
      this.$on('bridge',(val)=>{
        this.screenthreepage.cur = val
      });
      if (util.isEmpty(this.screenthreedata)) {
        getmjlsJsondata().then(res => {
            if (res.length > 0) {
              if (!util.isEmpty(res)) {
                this.isdata =false;
                this.screenthreedata = util.getJsonDetails(res,this.screenthreepage.num);
                this.datalist = this.screenthreedata['1'];
                this.screenthreepage.dataNum = res[0].pageSize;
                this.screenthreepage.all = Math.ceil(res[0].pageSize/this.screenthreepage.num)
              } else {
                this.isdata =true
              }
            }else {
              this.isdata =true
            }
          }
        ).catch((err) => {
          this.isdata =true
        })
      }
    },
    components: {
      Paging,
    },
    methods: {
      pageChange: function (page) {
        this.screenthreepage.cur = page;
        let data = {
          pageSize: this.screenthreepage.num,
          pageNum: this.screenthreepage.cur,
          columnId:REMEMBER
        };
        if (!this.screenthreedata[page] || this.screenthreedata[page].length < this.screenthreepage.num) {
          getmjlsAjaxdata(data).then((res) => {
            if (res.code == 200 && res.rows) {
              if (res.rows.length > 0) {
                this.datalist = res.rows
              }else {
                this.isdata =true
              }
            }
          }).catch(() => {
            this.isdata =true
          })
        } else {
          this.datalist = this.screenthreedata[page];
        }
      },
      handleHerf(id) {
        //直接调用$router.push 实现携带参数的跳转
        let routetele = this.$router.resolve({
          path: `/Details/${id}&&2`,
        })
        window.open(routetele.href, '_blank');
      },
    },
  }
</script>
<style scoped>
  .Picture-list{
    width: 194px;
    height: 532px;
    float: left;
  }
  .content-listimg-left {
    position: relative;
    width: 194px;
    height: 410px;
    background: url("../../../assets/img/zhengji.png") no-repeat;
    background-size: 100% 100%;
  }
  .content-listimg-bottom{
    position: absolute;
    top: 200px;
    left: 17px;
    width: 168px;
    height: 69px;
    font-size: 14px;
    color: black;
    text-align: left;
  }

  .content-listimg-left > h3 {
    position: absolute;
    top: 100px;
    left: 17px;
    width: 168px;
    height: 69px;
    font-size: 24px;
    font-family: Source Han Serif SC;
    font-weight: 800;
    color: rgba(225, 0, 0, 1);
  }
  .looking-forward,.memorial-service{
    width: 100%;
    height: 46px;
    margin-bottom: 20px;
    background-repeat: no-repeat !important;
    background-size: 100% 100% !important;
    cursor: pointer;
    text-align: center;
  }
  .looking-forward>a,.memorial-service>a{
    font-size: 22px;
    display: inline-block;
    color: white;
    line-height: 46px;
    font-weight: 700;
  }
  .looking-forward:hover,.memorial-service:hover{
    background: url("../../../assets/img/bacbulr.png");
  }

  .looking-forward{
   background: url("../../../assets/img/bacred.png");
  }
  .looking-forward>span{
    display: inline-block;
    width: 32px;
    height: 80%;
    margin-bottom: 7px;
    background:url("../../../assets/img/zyicon.png");
    background-size: 100% 100%;
    vertical-align: bottom;
    margin-left: -10px;
    margin-right: 10px;
    margin-top: 3px;
  }
  .memorial-service{
    background: url("../../../assets/img/bacred.png");
  }
  .memorial-service>span{
    display: inline-block;
    width: 32px;
    height: 80%;
    margin-bottom: 7px;
    background:url("../../../assets/img/lsmb.png");
    background-size: 100% 100%;
    vertical-align: bottom;
    margin-left: -10px;
    margin-right: 10px;
    margin-top: 3px;

  }

  .content-listimg-right {
    display: flex;
    flex-wrap: wrap;
    position: relative;
    float: left;

    width: 1188px;
    height: 100%;
  }

  .content-listimg-right > li {
    float: left;
    margin-left: 80px;
    width: 283px;
    height: 259px;
    box-shadow: 1px 2px 6px 0px rgba(118, 103, 1, 0.35);
    margin-bottom: 15px;
  }

  .listimg {
    width: 282px;
    height: 171.5px;
    cursor: pointer;
  }

  .listimg img {
    width: 100%;
    height: 100%;
    cursor: pointer;
  }

  .listtitle {
    box-sizing: border-box;
    text-align: left;
    width: 100%;
    height: 87px;
    padding: 19.7px;
    line-height: 26px;
    font-size: 17px;
    color: #000000;
    overflow: hidden;
    cursor: pointer;
    background-color: white;
  }

  .title-text {
    height: 55px;
    overflow: hidden;
  }

  .listtitle:hover {
    color: #40A9FF;
  }

  .content-listimg {
    display: inline-block;
    width: 1382px;
    height: 532px;
    margin-top: 20px;
  }

  .Remember {
    height: 100%;
    text-align: center;
  }

  .content {
    text-align: center;
    width: 100%;
    height: 100%;
  }

  .contentnr {
    width: 100%;
    float: left;
  }

  .top {
    position: relative;
    width: 100%;
    height: 226px;
  }

  .top > div {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 1382px;
    height: 193px;
    background: url("../../../assets/img/tophongqi.png") no-repeat;
    background-size: 100% 100%;
    border-radius: 6px;
  }
  .over{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    line-height: 500px;
    text-align: center;
    color: #aa0000;
    font-size: 25px;

  }
</style>



// WEBPACK FOOTER //
// src/pages/Home/components/remember.vue